// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__X-G1S","item":"Navbar_item__nLbpx","active":"Navbar_active__19Bd9"};